import 'dayjs/locale/zh-cn';

import dayjs, { Dayjs } from 'dayjs';
import duration from 'dayjs/plugin/duration.js';
import isoWeek from 'dayjs/plugin/isoWeek.js';
import relativeTime from 'dayjs/plugin/relativeTime.js';
import updateLocale from 'dayjs/plugin/updateLocale.js';

dayjs.locale('zh-cn');
dayjs.extend(duration);
dayjs.extend(isoWeek);
dayjs.extend(updateLocale);
dayjs.extend(relativeTime);

dayjs.updateLocale('zh-cn', {
  weekdays: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
});

export { dayjs };

export function weekFormat(timestamp: number = 0): string | undefined {
  return timestamp ? dayjs(timestamp).format('dddd') : undefined;
}

export function datetimeFormat(
  timestamp: number | string = 0,
): string | undefined {
  return timestamp ? dayjs(timestamp).format('YYYY-MM-DD HH:mm') : undefined;
}

export function timeFormat(
  timestamp: Dayjs | Date | number = 0,
): string | undefined {
  return timestamp ? dayjs(timestamp).format('HH:mm') : undefined;
}

export function dateFormat(
  timestamp: Dayjs | Date | number | string = 0,
): string | undefined {
  return timestamp ? dayjs(timestamp).format('YYYY-MM-DD') : undefined;
}

export function dateWithoutYearFormat(
  timestamp: number | string = 0,
): string | undefined {
  return timestamp ? dayjs(timestamp).format('MM-DD') : undefined;
}

export function timeAgo(timestamp: number = 0): string | undefined {
  if (!timestamp) {
    return undefined;
  }

  const time = dayjs(timestamp);
  const now = dayjs();

  // If timestamp is in the future, show formatted date
  if (time.isAfter(now)) {
    return dateFormat(timestamp);
  }

  // For dates a week or more in the past, show the formatted date
  const daysDifference = Math.abs(now.diff(time, 'day'));

  if (daysDifference >= 30) {
    return dateFormat(timestamp);
  }

  // For dates within the past week, show relative time
  return time.fromNow();
}

// export function dateFormatZH(timestamp?: number = 0): string | undefined {
//   return timestamp ? dayjs(timestamp).format('YYYY 年 M 月 D 日') : undefined;
// }

// export function durationFormat(milliseconds?: number = 0): string | undefined {
//   return milliseconds
//     ? milliseconds < 1000
//       ? '00:00'
//       : dayjs.duration(milliseconds).format('mm:ss')
//     : '';
// }

export function durationHumanFormat(milliseconds: number = 0): string {
  return milliseconds
    ? milliseconds < 1000
      ? '不到一秒'
      : dayjs
          .duration(milliseconds)
          .format('H 小时 m 分 s 秒')
          .replace(/^0\s小时\s/, '')
          .replace(/^0\s分\s/, '')
    : '0 秒';
}

export function tooLong(milliseconds: number = 0): boolean {
  return milliseconds >= 15 * 60 * 1000;
}

export function phoneMask(value?: string): string | undefined {
  return value && /^(?:\+86)?1\d{10}$/.test(value)
    ? `${value.slice(0, -8)}****${value.slice(-4)}`
    : value;
}

export function setTitle(title?: string): void {
  document.title = [title, import.meta.env.WATCHING ? '本地调试中' : '心相随']
    .filter(Boolean)
    .join(' | ');
}

export function money(value: number): string {
  return `￥${(value / 100).toFixed(2)}`;
}

export function renderMac(value?: string): string | undefined {
  const mac = value && value.match(/.{2}/g);

  return mac ? mac.join(':').toUpperCase() : undefined;
}
